import TemplateCategoryDeleteModal from './TemplateCategoryDeleteModal';
import {connect} from '../../app/connect';
import {deleteTemplateCategoryAction} from '../../app/templates/templates-actions';
import {getTemplateCategories, getUncategorizedTemplateCategory} from '../../app/templates/template-selectors';

const mapStateToProps = state => ({
  templateCategories: getTemplateCategories(state),
  uncategorizedCategory: getUncategorizedTemplateCategory(state)
});

const mapDispatchToProps = {
  deleteTemplateCategoryAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateCategoryDeleteModal);
